import React from 'react';

import { FieldGroup, Loading } from '../../../components';
import { Visible } from '../../../core/components';
import { getFileUrl } from '../../../core/config/api.js';

import { ConfirmButtons } from './ConfirmButtons';
import RequestForm from './RequestForm';
import BuyAlertPrompt from '../../../requests/components/molecules/BuyAlertPrompt.jsx';

const MobileView = ({
  handleSubmit,
  clientName,
  product,
  isUnknwon,
  isEditing,
  isOrder,
  setChoice,
  buttons,
  paidOffline,
  currency,
}) => {
  if (!product && !isUnknwon) {
    return (
      <Loading type="table" />
    );
  }

  return (
    <div className={`confirm-request-mobile ${isOrder ? 'source-req' : 'sell-req'}`}>
      <Visible when={clientName}>
        <div className="client-name">
          {clientName}
        </div>
        <hr className="separator" />
      </Visible>

      <Visible when={!isUnknwon}>
        <div className="-container">
          <img src={getFileUrl(product?.images?.[0]?.id)} width="181" />
        </div>
        <div className="brand">
          {product?.brand?.name}
        </div>
        <div className="model">
          {product?.model?.name}
        </div>
        <div className="description">
          {product?.values?.dial_color?.value}
          &nbsp;/&nbsp;
          {product?.values?.case_diameter?.value}
        </div>
        <div className="ref-number">
          {product?.reference_number}
        </div>
      </Visible>

      <div className="form">
        <RequestForm {...{ isOrder, paidOffline, isEditing }} />
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <h4>Real Images</h4>
        </div>
        <div className="col-12">
          <FieldGroup
            className={'mt-0'}
            placeholder=""
            name="images"
            type="galleryUpload"
          />
        </div>
      </div>

      {/* Orders only: a sell request is us buying, so there is no supplier
          to watch for. */}
      {isOrder && <BuyAlertPrompt currency={currency} />}

      <ConfirmButtons {...{ handleSubmit, setChoice, buttons }} />
    </div>
  );
}

export default MobileView;
